import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import img01 from './../assets/solutions_products/workforce.png';
import 'animate.css/animate.min.css';

export default function Workforce() {
    return (
        <Container className='digital'>
            <h2 className="text-center title">Workforce & Ops Management</h2>
            <Row>
                <div className='responsive-title'>Where People, Platforms, and Productivity Align</div>
                <div className='responsive-title'>Managing Outsourced Teams</div>
                <div className='responsive-title'>Doesn't Have to Be Messy</div>
            </Row>
            <Row className='mt-4'>
                <p className='text-center mb-4 content'>
                    We streamline your workforce operations through modular, mobile ready, and data driven tools that connect people, processes, and platforms all in real time.
                </p>
                <p className='text-center mb-4 content'>
                    From recruitment to reporting, we turn field chaos into operational clarity.
                </p>
            </Row>

            <Row>
                <Col md={6} className='mb-4'>
                    <div className='mb-4 box'>
                        <div className='mb-4 box-title'>
                            What's Inside The System:
                        </div>

                        <Row>
                            <div style={{ marginBottom: '20px' }}>
                                <h4>Talent Management</h4>
                                <p>Source, assign, and manage the right people faster, smarter, and at scale.</p>
                            </div>

                            <div style={{ marginBottom: '20px' }}>
                                <h4>Workforce Platforms</h4>
                                <p>Digitized portals that track attendance, tasks, and performance all in one place.</p>
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <h4>Integrated VAS</h4>
                                <p>Plug-and-play digital services to enhance field capabilities and user engagement.</p>
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <h4>Mobile Canvasing</h4>
                                <p>Geo-enabled mobile tools to manage outreach, sales, or surveys on the move.</p>
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <h4>Outsourcing Dashboards & Apps</h4>
                                <p>Custom dashboards for instant insights and smoother coordination with external teams.</p>
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <h4>End-to-End Outsourcing Solutions</h4>
                                <p>From onboarding to offboarding, we help you run outsourced operations like your own.</p>
                            </div>
                        </Row>
                    </div>
                </Col>
                <Col md={6} className='mb-4'>
                    <img src={img01} alt="Telecom Innovation Stack" className='img-fluid' style={{ width: '100%', height: 'auto', borderRadius: '25px' }} />
                </Col>
            </Row>
        </Container>
    );
}
